import React, { Component } from "react";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import NewsModal from "./newsModal";
import { wasNewsShownThisLogin, markNewsShownThisLogin } from "../../utils/newsLoginSession";
import "../../styles/news/news.scss";

class NewsLoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeNews: null,
      show: false,
    };
  }

  componentDidMount() {
    if (window.location.pathname === "/login" || !localStorage.getItem("token")) {
      return;
    }

    this.loadActiveNews();
  }

  componentWillUnmount() {
    this.dismissed = true;
    if (this.requestCancel) this.requestCancel.cancel();
  }

  handleReady = () => {
    if (this.dismissed || this.loginToken !== localStorage.getItem("token")) return;
    this.contentReady = true;
    markNewsShownThisLogin(this.state.activeNews);
  };

  loadActiveNews = async () => {
    this.dismissed = false;
    this.loginToken = localStorage.getItem("token");
    this.contentReady = false;
    this.requestCancel = axios.CancelToken.source();
    try {
      const response = await axios.get(`${apiHost}/api/News/Active`, {
        timeout: 30000,
        cancelToken: this.requestCancel.token,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      if (this.dismissed || this.loginToken !== localStorage.getItem("token")) return;
      if (response.status === 200 && response.data && response.data.id && !wasNewsShownThisLogin(response.data)) {
        this.setState({ activeNews: response.data, show: true });
      } else {
        this.setState({ show: false });
      }
    } catch (error) {
      if (!this.dismissed) this.setState({ show: false });
      if (!axios.isCancel(error)) console.log(`News active communication request failed: ${error}`);
    }
  };

  handleClose = async () => {
    const activeNews = this.state.activeNews;
    this.dismissed = true;
    if (this.requestCancel) this.requestCancel.cancel();
    this.setState({ show: false });

    if (!activeNews || !this.contentReady) {
      return;
    }

    try {
      await axios.post(
        `${apiHost}/api/News/${activeNews.id}/Acknowledge`,
        { version: activeNews.version },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
    } catch (error) {
      console.log(`News acknowledgement request failed: ${error}`);
    }
  };

  render() {
    return (
      <NewsModal
        item={this.state.activeNews}
        onReady={this.handleReady}
        show={this.state.show}
        onHide={this.handleClose}
        onCloseLabel="Close"
      />
    );
  }
}

export default NewsLoginModal;
